import { LOGOUT, REPORT, REPORT_RESET } from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case LOGOUT:
      return {}
    case REPORT_RESET:
      return {}
    case REPORT:
      if(action.error){
        return {
          ...state,
          data:[],
        }
      }
      return {
        ...state,
        data: action.payload.data.data
      }
    default:
      return state
  }

  return state
}



// WEBPACK FOOTER //
// src/reducers/report.js